import { kebab } from 'change-case';

export const parseToDataCyAttr = (value) =>
  value && typeof value === 'string' ? kebab(value.toLowerCase().trim()) : '';
